export default "__VITE_ASSET__Beq42UQU__"